var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.classes },
    [
      _vm._l(_vm.maxUsers, function(user, index) {
        return _c(
          "span",
          {
            key: user.personId,
            class: {
              "user-avatar-spread__avatar": true,
              "user-avatar-spread__avatar--first": index === 0
            },
            style:
              "height:" +
              _vm.avatarSize +
              ";margin-left:" +
              _vm.avatarMargin +
              "px;",
            attrs: { title: _vm.userName(user) },
            on: {
              click: function($event) {
                return _vm.onAvatarClicked($event, user)
              },
              mouseover: function($event) {
                return _vm.onAvatarMouseOver($event, user)
              }
            }
          },
          [
            _c(
              "v-avatar",
              {
                class: {
                  "user-avatar-spread__avatar--forefront": _vm.isForefrontAvatar(
                    user
                  )
                },
                style: _vm.avatarStyle,
                attrs: { color: _vm._avatarColor, size: _vm.avatarSize }
              },
              [
                user.picture
                  ? _c("img", {
                      attrs: { alt: _vm.userName(user), src: user.picture }
                    })
                  : _c(
                      "span",
                      {
                        staticClass: "white--text user-initials",
                        style: "font-size: calc(" + _vm.avatarSize + " * 0.6)"
                      },
                      [_vm._v(_vm._s(_vm._f("initials")(user)))]
                    )
              ]
            ),
            _vm._v(" "),
            _c("font-awesome-icon", {
              class: {
                "user-avatar-spread__positive-badge": true,
                "user-avatar-spread__positive-badge--visible": _vm.isPositiveBadgeVisible(
                  user
                )
              },
              attrs: { icon: ["fad", "check-circle"], size: _vm.badgeSize }
            })
          ],
          1
        )
      }),
      _vm._v(" "),
      _vm.exceedsMaxAvatarLength
        ? _c(
            "span",
            {
              staticClass: "user-avatar-spread__avatar",
              style:
                "height:" +
                _vm.avatarSize +
                ";margin-left:" +
                _vm.avatarMargin +
                "px;"
            },
            [
              _c(
                "v-avatar",
                { attrs: { color: _vm._avatarColor, size: _vm.avatarSize } },
                [
                  _c(
                    "span",
                    {
                      staticClass: "white--text user-initials",
                      style: "font-size: calc(" + _vm.avatarSize + " * 0.6)"
                    },
                    [_vm._v("+" + _vm._s(_vm.hiddenUserCount))]
                  )
                ]
              )
            ],
            1
          )
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c2fc447", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c2fc447","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserAvatarSpread.vue
// module id = wvG3
// module chunks = 5